import styled from "styled-components";
import { typography, colors } from "src/theme";
import device from "src/constants/media";

export const Wrapper = styled.div`
  position: relative;
`;
export const Wawes = styled.div`
  position: absolute;
  width: 100%;
  height: 888px;
  top: 150px;
  background-image: url("/background/Waves.svg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
`;

export const Content = styled.div`
  position: relative;
  max-width: 1096px;
  margin: 0 auto;
  z-index: 1;
`;

export const Title = styled.p`
  padding-left: 12px;
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: 500;
  font-size: 36px;
  line-height: 44px;
  color: ${colors.white};

  @media ${device.mobileM} {
    padding-left: 24px;
  }
  @media ${device.laptop} {
    padding: 0 68px;
  }
  @media ${device.laptopS} {
    padding: 0;
  }
`;

export const PlacesWrapper = styled.div`
  display: flex;

  @media ${device.laptop} {
    padding: 48px 68px 0;
  }
  @media ${device.laptopS} {
    padding: 48px 0 0;
  }
`;

export const PlacesColumn = styled.div`
  width: 100%;

  :not(:last-child) {
    margin-right: 3.7%;
  }
`;

export const ListWrapper = styled.div`
  padding: 48px 24px;

  @media ${device.laptop} {
    padding: 0 44px 0 68px;
  }
  @media ${device.laptopS} {
    padding: 0 136px;
  }
`;

export const DropdownWrapper = styled.div`
  margin-bottom: 8px;
`;

export const ButtonContainer = styled.div`
  margin: 48px auto 0;

  @media ${device.laptop} {
    display: none;
  }
`;
